// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".namer{display:inline-block;width:100%}.editable .hover-row:hover .namer{display:inline-block;width:80%}.hover-row:hover .trash{display:inline-block}", ""]);
